import module from 'module';
const templateUrl = require('./pawn-auction-branches.template.html');

module.component('pawnAuctionBranches', {
  templateUrl,
  controller: function () {
  }
});
